
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['freeFormInput'];

  showFreeForm(event) {
    this.freeFormInputTarget.classList.remove('d-none');
    this.freeFormInputTarget.querySelector('#id_free_form_request').focus();
  }
}

